if (!customElements.get('dealzo-product-details')) {
  customElements.define('dealzo-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.organizeContent();
      this.tabs = [...this.querySelectorAll('[data-panel]')];
      this.panels = [...this.querySelectorAll('[data-details-panel]')];
      this.querySelector('[data-details-nav]').setAttribute('role', 'tablist');
      this.panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = 0;
      });
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.hash.slice(1));
        tab.addEventListener('click', event => {
          event.preventDefault();
          this.select(index);
        });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.select(0);
      this.classList.add('is-ready');
    }

    select(index) {
      this.tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[position].hidden = !selected;
      });
    }

    organizeContent() {
      const description = this.querySelector('[data-description]');
      const destinations = {
        description,
        technical: this.querySelector('[data-technical]'),
        warnings: this.querySelector('[data-warnings]')
      };
      // Flatten only presentation wrappers; keep lists, tables and media intact.
      const flatten = parent => [...parent.childNodes].flatMap(node => {
        if (node.nodeType === 1 && /^(DIV|SECTION|ARTICLE)$/.test(node.tagName) && node.querySelector('h1,h2,h3,h4,h5,h6')) return flatten(node);
        return [node];
      });
      const nodes = flatten(description);
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      let destination = 'description';
      let sectionLevel = 7;
      for (const node of nodes) {
        if (node.nodeType === 1 && /^H[1-6]$/.test(node.tagName)) {
          const text = normalize(node.textContent);
          const level = Number(node.tagName[1]);
          if (/specificatii|detalii tehnice|date tehnice|caracteristici tehnice|technical|specifications/.test(text)) {
            destination = 'technical';
            sectionLevel = level;
          } else if (/atentionari|avertismente|precautii|siguranta in utilizare|instructiuni de siguranta|warnings|safety instructions|notices/.test(text)) {
            destination = 'warnings';
            sectionLevel = level;
          } else if (level <= sectionLevel) {
            destination = 'description';
            sectionLevel = 7;
          }
        }
        // A closing sales paragraph belongs to the overview, not to the specifications.
        if (destination === 'technical' && node.nodeType === 1 && node.tagName === 'P' && /comanda|cumpara|fa-ti|alege acum|adauga acum|nu rata/.test(normalize(node.textContent))) destination = 'description';
        destinations[destination].append(node);
      }
      ['technical', 'warnings'].forEach(kind => {
        const content = destinations[kind];
        this.querySelector(`[data-fallback="${kind}"]`).hidden = !!content.textContent.trim() || !!content.querySelector('img,video,iframe,table');
      });
      this.querySelectorAll('.dealzo-details-content img').forEach(image => {
        image.loading = 'lazy';
        image.decoding = 'async';
      });
      this.querySelectorAll('.dealzo-details-content table').forEach(table => {
        const wrapper = document.createElement('div');
        wrapper.className = 'dealzo-details-table';
        table.before(wrapper);
        wrapper.append(table);
      });
    }
  });
}
